import { render, staticRenderFns } from "./SpacesContent.vue?vue&type=template&id=3a09715b&scoped=true&"
import script from "./SpacesContent.vue?vue&type=script&lang=js&"
export * from "./SpacesContent.vue?vue&type=script&lang=js&"
import style0 from "./SpacesContent.vue?vue&type=style&index=0&id=3a09715b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a09715b",
  null
  
)

export default component.exports